import { LOCALSTORAGE_TOKEN, LOCALSTORAGE_USER_ID } from "../../config";
import axios from "axios";

export function postNewEntryService(entry) {
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN);
  const userId = localStorage.getItem(LOCALSTORAGE_USER_ID);
  let config = { headers: { Authorization: `bearer ${token}` } };

  return axios.post(
    `${process.env.API_BASE_URL}/api/users/${userId}/entries`,
    { entry: entry },
    config
  );
}

export async function getHappinessForUser(userId) {
  let token = localStorage.getItem(LOCALSTORAGE_TOKEN);
  let config = { headers: { Authorization: `bearer ${token}` } };

  const data = await axios.get(
    `${process.env.API_BASE_URL}/api/users/${userId}/entries`,
    config
  );
  return data.data;
}



// WEBPACK FOOTER //
// ./src/modules/diary/services.js